<h3>{{ 'iackathon.rating_others' | translate }}</h3>

@for (groupId of otherGroups(); track groupId) {
    <div>
        <h4>{{groupId}}</h4>
        {{ratingOthers()[groupId] | json}}
    </div>
}